"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgLargeStatusYellow = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none" }, props),
    React.createElement("circle", { cx: 10, cy: 10, r: 9, fill: "#9F8849" }),
    React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M10.94 10.383a.985.985 0 0 1-.979.977.973.973 0 0 1-.965-.977V6.477c0-.534.417-.977.965-.977s.992.443.979.977zm-.927 1.966c.105 0 .21.013.313.066.627.156 1.11.703 1.11 1.393 0 .807-.666 1.458-1.475 1.458A1.457 1.457 0 0 1 8.5 13.808c0-.703.509-1.263 1.174-1.406a.8.8 0 0 1 .235-.053l.022-.005a.2.2 0 0 1 .043-.008q.01.001.02.007.01.005.02.006", clipRule: "evenodd" })));
exports.default = SvgLargeStatusYellow;
